const translations = {
  en: {
    language: {
      label: "Language",
      selectPrompt: "Select your language:",
      english: "English",
      chinese: "中文",
      spanish: "Español",
      russian: "Русский",
    },

    login: {
      brand: "ACE Massage Hub",
      headline: "Prepare Smarter. Pass the MBLEx with Confidence.",
      subtitle:
        "A complete MBLEx preparation platform built around realistic exam practice, adaptive learning, topic-based study, and multilingual AI explanations.",

      featureExam: "Realistic MBLEx Exam Simulation",
      featureExamDesc:
        "Practice with exam-style questions designed to prepare you for the real MBLEx experience.",

      featureAdaptive: "Adaptive Learning",
      featureAdaptiveDesc:
        "Practice adapts to your progress so you can focus on the areas that need the most improvement.",

      featureTopics: "Learn by Topic",
      featureTopicsDesc:
        "Strengthen specific knowledge areas and identify your weak topics before exam day.",

      featureAI: "AI Explanations in Your Language",
      featureAIDesc:
        "Understand difficult questions with AI explanations available in English, Chinese, Spanish, and Russian.",

      studentLogin: "Student Login",
      loginSubtitle:
        "Log in to access your question banks and study tools.",
      email: "Email",
      password: "Password",
      loginButton: "Login",
      forgotPassword: "Forgot Password?",
      createAccount: "Create Account",
      noAccount: "New student?",

      studentSignup: "Student Signup",
      signupSubtitle:
        "Create your student account to access the study platform.",
      fullName: "Full Name",
      username: "Username",
      signupButton: "Sign Up",
      alreadyHaveAccount: "Already have an account? Login",

      resetPassword: "Reset Password",
      resetPasswordSubtitle: "Enter your new password below.",
      newPassword: "New Password",
      updatePassword: "Update Password",

      welcomeBack: "Welcome Back",
      superUserAccess: "SuperUser Access",
      adminDashboard: "Admin Dashboard",
      logout: "Logout",
      security: "Your information is securely protected.",
    },

    home: {
        practiceQuestions: "Practice Questions",
        practiceQuestionsDesc:
            "Build exam confidence with realistic MBLEx-style practice questions.",

        learningCenter: "Learning Center",
        learningCenterDesc:
            "Study structured notes, key concepts, and massage theory.",

        vocabulary: "Vocabulary",
        vocabularyDesc:
            "Master essential massage terminology and definitions.",

        wrongQuestions: "Wrong Questions",
        wrongQuestionsDesc:
            "Review missed questions and strengthen your weak areas.",

        welcomeBack: "Welcome back,",
        keepBuilding: "Keep building your knowledge",
        myAccount: "My Account",
        logout: "Logout",

        currentAccess: "Current Access",
        questionsUsed: "Questions Used",
        questionsRemaining: "Questions Remaining",
        membershipStatus: "Membership Status",

        superUser: "SuperUser",
        premiumTrial: "Premium Trial",
        premium: "Premium",
        free: "Free",

        monthlyPlan: "Monthly Plan",
        quarterlyPlan: "Quarterly Plan",

        premiumAccess: "Premium Access",
        ofFreeQuestions: "of 50 Free Questions",

        unlimited: "Unlimited",
        fullQuestionBank: "Full Question Bank",
        freeAccess: "Free Access",

        permanentAccess: "Permanent Access",
        paymentIssue: "Payment Issue",
        trialActive: "Trial Active",
        cancellationScheduled: "Cancellation Scheduled",
        active: "Active",
        ended: "Ended",
        loading: "Loading...",

        fullPremiumAccess: "Full premium access",
        trialEnds: "Trial ends {date}",
        accessUntil: "Access until {date}",
        renewsOn: "Renews on {date}",
        updatePaymentMethod: "Update payment method",
        upgradeAnytime: "Upgrade anytime",
        stayConsistent: "and stay consistent.",

        appTitle: "Massage Exam Practice App",
        appTagline: "Study Smart. Practice Hard. Pass with Confidence.",
        studyPractice: "Study & Practice",
        studyPracticeDesc: "Everything you need to prepare, review, and strengthen your exam knowledge.",

        continueEducation: "Continue Your Education",
        continueEducationDesc: "Build stronger foundations in anatomy, pathology, ethics, and professional practice.",

        structuredStudyMaterials: "Structured study materials",
        examStrategyReview: "Exam strategy and review",
        anatomyRefreshers: "Anatomy & physiology refreshers",
        ethicsProfessionalConcepts: "Ethics and professional concepts",

        goToLearningCenter: "Go to Learning Center",

        buildKnowledge: "Build Knowledge.",
        buildConfidence: "Build Confidence.",
        learnAnyDevice: "Learn at your own pace from any device.",

        advanceCareer: "Advance Your Career",
        ceProfessionalDesc:
        "Continuing education courses for massage professionals.",
        browseCeCourses: "Browse CE Courses",
        viewCourse: "View Course",
        mostPopular: "Most Popular",

        comingSoon: "COMING SOON",
        ceCoursesComingSoon: "CE COURSES COMING SOON",
        ceComingSoonDesc:
        "Complete high-quality continuing education courses online and learn from experienced massage therapy instructors.",

        onlineLearning: "100% Online",
        onlineLearningDesc:
        "Learn at your own pace from anywhere.",

        continuingEducation: "Continuing Education",
        continuingEducationDesc:
        "Designed to support massage license renewal requirements where accepted by your state licensing board.",

        experiencedInstructors: "Experienced Instructors",
        experiencedInstructorsDesc:
        "Learn from experienced massage therapy professionals and educators.",

        ceComingSoonFooter:
        "We are building practical, high-quality CE courses to support your professional growth and continuing education needs.",

        deepTissueCourse: "Deep Tissue Massage Techniques",
        deepTissueCourseDesc:
        "Advanced techniques for targeting deep muscle tension and improving client outcomes.",

        anatomyCourse: "Anatomy & Physiology Refresher",
        anatomyCourseDesc:
        "Essential anatomy review for massage therapists and exam preparation.",

        painManagementCourse: "Pain Management Strategies",
        painManagementCourseDesc:
        "Evidence-based approaches to pain relief, client care, and treatment planning.",

        ceHours: "{count} CE Hours",

        examFocused: "Exam Focused",
        examFocusedDesc: "Built for licensing exam preparation",

        structuredLearning: "Structured Learning",
        structuredLearningDesc: "Learn concepts before testing yourself",

        trackProgress: "Track Progress",
        trackProgressDesc: "Review performance and weak areas",

        anywhereAnytime: "Anywhere, Anytime",
        anywhereAnytimeDesc: "Study on your own schedule",
    },

    practice: {
      center: "PRACTICE CENTER",
      readinessTitle: "Build Your MBLEx Readiness",
      readinessDesc:
        "Practice smarter with personalized questions, or focus on a specific subject you want to strengthen.",
      back: "Back",

      recommended: "RECOMMENDED",
      smartPractice: "Smart Practice",
      smartPracticeDesc:
        "Personalized practice that automatically adapts to your performance.",
      tenQuestionsPerRound: "10 questions per round",
      focusesWeakAreas: "Focuses on your weak areas",
      prioritizesReview: "Prioritizes questions due for review",
      adjustsDifficulty: "Difficulty adjusts automatically",

      currentRound: "Current Round",
      unfinishedRound:
        "You have an unfinished Smart Practice round.",
      continueSmartPractice: "Continue Smart Practice",
      startSmartPractice: "Start Smart Practice",
      startNewRound: "Start New Round",

      practiceBySubject: "Practice by Subject",
      practiceBySubjectDesc:
        "Choose exactly what you want to review and strengthen.",
      reviewAfterClass: "Review material after class",
      prepareQuizzesExams: "Prepare for quizzes and exams",
      targetWeakSubject: "Target a specific weak subject",
      practiceIndividualTopics: "Practice individual topics",
      chooseSubject: "Choose a Subject",

      howSmartPracticeWorks: "How Smart Practice works",
      howSmartPracticeWorksDesc:
        "Smart Practice uses your performance, mastery, review schedule, and question difficulty to build each round. Complete a 10-question round and your next set automatically adapts to your latest results.",

      startNewRoundTitle: "Start a New Round?",
      startNewRoundWarning:
        "You currently have an unfinished Smart Practice round. Starting a new round will abandon your current progress and create a new set of adaptive questions.",
      continueCurrentRound: "No, Continue Current Round",
      confirmStartNewRound: "Yes, Start New Round",

      practiceQuestions: "Practice Questions",
      questionProgress: "Question {current} of {total}",

      mblExEnglishNoteTitle: "MBLEx Exam Note",
      mblExEnglishNote:
        "The MBLEx is administered in English, so practice questions and answer choices are displayed in English. After answering, you can use AI Explanation to view a translation and detailed explanation in your selected language.",

      loadingPracticeQuestions: "Loading practice questions...",
      noPracticeQuestion: "No practice question found.",
      checkingAnswer: "Checking answer...",

      correct: "Correct!",
      incorrect: "Incorrect",
      correctAnswer: "Correct answer:",

      needMoreExplanation: "Need more explanation?",
      aiTutorDesc:
        "Use the AI tutor to view a translation of the question and a detailed explanation of the answer.",

      explainEnglish: "Explain in English",
      explainChinese: "Explain in Chinese",
      explainSpanish: "Explain in Spanish",
      explainRussian: "Explain in Russian",
      loadingExplanation: "Loading...",

      aiExplanation: "AI Explanation",
      source: "Source:",
      explanationHelpful: "Was this explanation helpful?",
      helpful: "Helpful",
      notHelpful: "Not Helpful",
      savingFeedback: "Saving feedback...",
      thanksFeedback: "Thanks for your feedback.",

      previous: "Previous",
      next: "Next",
      finishRound: "Finish Round",
      loadingSubjects: "Loading subjects...",
      noSubjectsFound: "No subjects found.",

      topics: "Topics",
      chooseTopicDesc:
        "Choose a topic to practice. If you already have an unfinished round, you can continue from where you left off.",
      loadingTopics: "Loading topics...",
      noTopicsFound: "No topics found for this subject.",
      roundInProgress: "Round in progress",
      questionsCompleted: "questions completed",
      continuePractice: "Continue Practice",
      startPractice: "Start Practice",
      subjectRoundWarningBefore:
        "You currently have an unfinished practice round for",
      subjectRoundWarningAfter:
        "Starting a new round will abandon your current progress and generate a new adaptive set of questions.",
    },

    wrongQuestion: {
      title: "Wrong Questions",
      center: "Wrong Question Center",
      loading: "Loading your wrong questions...",
      heroTitle: "Turn Mistakes Into Mastery",
      heroDesc:
        "Questions you miss are saved automatically. Review them when they're due, or practice your weak questions anytime.",

      questionsMissed: "Questions Missed",
      needPractice: "Need Practice",
      dueNow: "Due Now",
      mastered: "Mastered",
      totalIncorrectAttempts: "Total incorrect attempts",

      noWrongQuestions: "No wrong questions yet",
      noWrongQuestionsDesc:
        "Questions you miss during practice will automatically appear here.",

      recommended: "RECOMMENDED",
      reviewDueQuestions: "Review Due Questions",
      reviewDueDesc:
        "Follow your personalized review schedule. These are the questions the app thinks you should review now.",
      reviewDueFeature1: "Reviews questions when they're due",
      reviewDueFeature2: "Uses spaced repetition",
      reviewDueFeature3: "Focuses on what needs attention now",
      reviewDueFeature4: "Helps prevent forgetting",
      questionsReadyNow: "questions ready now",
      questionReadyNow: "question ready now",
      caughtUp: "You're caught up for now",
      startDueReview: "Start Due Review",
      nothingDue: "Nothing Due Right Now",
      dueQuestionsPerRound: "Up to 10 due questions per round",

      practiceWrongQuestions: "Practice Wrong Questions",
      practiceWrongDesc:
        "Practice your unmastered wrong questions anytime, even if they are not scheduled for review yet.",
      practiceFeature1: "Practice whenever you want",
      practiceFeature2: "Focus on questions you've missed",
      practiceFeature3: "Up to 10 questions per round",
      practiceFeature4: "Correct answers still build mastery",
      questionsNeedPractice: "questions still need practice",
      questionNeedPractice: "question still needs practice",
      noActiveWrongQuestions: "No active wrong questions",
      practiceBeforeDue: "Practice even before questions are due",

      whichChoose: "Which one should I choose?",
      whichChooseBefore:
        "follows your personalized review schedule and is the recommended choice for regular daily study.",
      whichChooseAfter:
        "lets you study your weak questions anytime, even before the app says they are due.",

      howItWorks: "How Wrong Questions Works",
      step1: "STEP 1",
      step1Title: "Miss a Question",
      step1Desc:
        "Any question you answer incorrectly is automatically added to Wrong Questions.",
      step2: "STEP 2",
      step2Title: "Review Over Time",
      step2Desc:
        "The app schedules future reviews based on how well you are learning each question.",
      step3: "STEP 3",
      step3Title: "Build Mastery",
      step3Desc:
        "Correct answers increase your mastery. If you miss the question again, it stays in active practice.",
      step4: "STEP 4",
      step4Title: "Master the Question",
      step4Desc:
        "Answer the question correctly 3 times in a row and it moves to Mastered.",
    },

    learningCenter: {
      title: "Learning Center",
      subtitle: "Study MBLEx concepts by unit and topic.",
      backHome: "Back Home",
      loadingUnits: "Loading learning units...",
      unit: "Unit",
      defaultUnitDescription: "MBLEx learning unit",
      startLearning: "Start Learning",
    },

    learningUnit: {
      unit: "Unit",
      back: "Back",
      loadingTopics: "Loading topics...",
      studyTopic: "Study Topic",
    },

    learningTopic: {
      topic: "Topic",
      back: "Back",
      partsReviewed: "{reviewed} of {total} parts reviewed",
      complete: "complete",
      learningContent: "Learning Content",
      noContent: "No topic content found.",
      reviewed: "Reviewed",
      undo: "Undo",
      markReviewed: "Mark as Reviewed",
      practice: "Practice",
      noExercises: "No exercises for this topic yet.",
    },

    account: {
      backToHome: "Back to Home",
      title: "My Account",
      subtitle: "Manage your account, subscription, and learning access.",

      account: "ACCOUNT",
      profile: "Profile",

      subscription: "SUBSCRIPTION",
      currentPlan: "Current Plan",
      loading: "Loading...",

      superUserPremium: "SuperUser Premium",
      premiumTrial: "Premium Trial",
      premiumMonthly: "Premium Monthly",
      premiumQuarterly: "Premium Quarterly",
      premium: "Premium",
      freePlan: "Free Plan",

      permanentAccess: "Permanent Access",
      threeDayFreeTrial: "3-Day Free Trial",
      perMonthPrice: "$21.99 / month",
      perThreeMonthsPrice: "$59.97 / 3 months",
      freePrice: "$0",

      active: "Active",
      paymentIssue: "Payment Issue",
      trialActive: "Trial Active",
      cancellationScheduled: "Cancellation Scheduled",
      ended: "Ended",
      free: "Free",

      permanentPremiumDesc: "You have permanent Premium access.",
      trialEndsOn: "Your free trial ends on {date}.",
      premiumTrialActive: "Your Premium trial is currently active.",
      paymentPaused:
        "Your Premium access is temporarily paused because your payment could not be completed.",
      subscriptionEndsOn:
        "Your subscription is scheduled to end on {date}. You will keep Premium access until then.",
      subscriptionCancellationScheduled:
        "Your subscription is scheduled for cancellation.",
      subscriptionRenewsOn:
        "Your subscription will renew on {date}.",
      previousSubscriptionEnded:
        "Your previous Premium subscription has ended. Your learning progress is still saved.",
      usingFreePlan: "You are currently using the Free plan.",

      updatePaymentMethod: "Update Payment Method",
      manageSubscription: "Manage Subscription",

      plan: "Plan",
      status: "Status",
      billing: "Billing",
      trialEnds: "Trial Ends",
      accessUntil: "Access Until",
      nextBillingDate: "Next Billing Date",

      notApplicable: "Not Applicable",
      trial: "Trial",
      monthly: "Monthly",
      quarterly: "Quarterly",
      permanent: "Permanent",

      learningAccess: "LEARNING ACCESS",
      yourAccess: "Your Access",

      practiceQuestions: "Practice Questions",
      unlimited: "Unlimited",
      remaining: "{count} Remaining",
      fullQuestionBankAccess: "Full question bank access",
      freeQuestionsUsed: "{used} of {limit} free questions used",

      wrongQuestions: "Wrong Questions",
      included: "Included",
      wrongQuestionsDesc: "Review previously missed questions.",

      learningCenter: "Learning Center",
      unlocked: "Unlocked",
      premiumAccess: "Premium",
      learningCenterDesc:
        "Structured learning materials and study content.",

      vocabulary: "Vocabulary",
      vocabularyDesc: "Vocabulary study, review, and practice.",

      premiumLabel: "PREMIUM",
      upgradeToPremium: "Upgrade to Premium",
      upgradeDesc:
        "Unlock the full question bank, Learning Center, Vocabulary, and Premium study features.",

      monthlyPlan: "Monthly",
      quarterlyPlan: "Quarterly",
      perMonth: "per month",
      everyThreeMonths: "every 3 months",
      equivalentMonthly: "Equivalent to $19.99 / month",

      fullPremiumAccess: "Full Premium access",
      unlimitedAI: "Unlimited AI explanations",
      cancelAnytime: "Cancel anytime",
      threeDayTrialEligible: "3-day trial for eligible new subscribers",
      saveSixDollars: "Save $6 every 3 months",

      startMonthly: "Start Monthly",
      startQuarterly: "Start Quarterly",
      mostValuable: "MOST VALUABLE",

      progressSaved: "Your progress is always saved",
      progressSavedDesc:
        "Canceling or changing your subscription does not delete your practice history, wrong questions, mastery progress, or learning data.",

      returnToHome: "Return to Home",
      manualPaidAccess: "Manual Paid Access",
      manualPaidAccessDesc:
        "Your Premium access was activated directly by ACE Massage Hub and remains active until {date}.",
      noAutoRenewal: "No Auto-Renewal",
      noAutoRenewalDesc:
        "This plan does not renew automatically.",
      paymentSource: "Payment Source",
      manualPayment: "Manual Payment",
      renewManualAccess: "Renew Your Access",
      renewManualAccessDesc:
        "To renew or extend your access, please contact ACE Massage Hub.",
      contactForRenewal: "Contact for Renewal",
      address: "Address",
      phone: "Phone",
      wechat: "WeChat",
      email: "Email",

      otherPaymentOptions: "Other Payment Options",
      preferAnotherPaymentMethod: "Prefer to pay another way?",
      manualPaymentAvailable:
        "We also accept manual payments. Contact ACE Massage Hub to purchase Premium access by Cash, Zelle, Venmo, PayPal, Bank Transfer, or Check.",
      manualPaymentNoAutoRenew:
        "Manual payment plans do not renew automatically.",
      acceptedPaymentMethods: "Accepted: Cash, Zelle, Venmo, PayPal, Bank Transfer, Check",
    },

    footer: {
      copyright: "© 2026 Massage Exam Practice App. All rights reserved.",
      terms: "Terms of Use",
      privacy: "Privacy Policy",
      contact: "Contact Us",
    },
  },

  zh: {
    language: {
      label: "语言",
      selectPrompt: "选择您的语言：",
      english: "English",
      chinese: "中文",
      spanish: "Español",
      russian: "Русский",
    },

    login: {
      brand: "ACE Massage Hub",
      headline: "更高效地备考，更有信心通过 MBLEx。",
      subtitle:
        "一站式 MBLEx 备考平台，通过真实考试模拟、自适应学习、按主题练习以及多语言 AI 解析，帮助你更有效地准备考试。",

      featureExam: "真实 MBLEx 考试模拟",
      featureExamDesc:
        "通过贴近真实 MBLEx 考试形式的题目进行练习，提前熟悉考试体验。",

      featureAdaptive: "自适应学习",
      featureAdaptiveDesc:
        "系统根据你的学习进度调整练习重点，帮助你集中提高薄弱知识点。",

      featureTopics: "按主题学习",
      featureTopicsDesc:
        "针对不同知识领域进行专项练习，在考试前发现并强化自己的薄弱主题。",

      featureAI: "使用你的语言进行 AI 解析",
      featureAIDesc:
        "遇到难题时，可以使用英语、中文、西班牙语或俄语获得 AI 智能解析。",

      studentLogin: "学生登录",
      loginSubtitle: "登录后即可使用题库和学习工具。",
      email: "邮箱",
      password: "密码",
      loginButton: "登录",
      forgotPassword: "忘记密码？",
      createAccount: "创建账户",
      noAccount: "新用户？",

      studentSignup: "学生注册",
      signupSubtitle: "创建学生账户，即可开始使用学习平台。",
      fullName: "姓名",
      username: "用户名",
      signupButton: "注册",
      alreadyHaveAccount: "已有账户？登录",

      resetPassword: "重置密码",
      resetPasswordSubtitle: "请在下方输入你的新密码。",
      newPassword: "新密码",
      updatePassword: "更新密码",

      welcomeBack: "欢迎回来",
      superUserAccess: "超级管理员权限",
      adminDashboard: "管理员控制台",
      logout: "退出登录",
      security: "您的账户信息将受到安全保护。",
    },

    home: {
        practiceQuestions: "模拟练习",
        practiceQuestionsDesc:
            "通过贴近真实 MBLEx 考试形式的练习题，提升应试能力和信心。",

        learningCenter: "学习中心",
        learningCenterDesc:
            "学习系统化课程笔记、核心知识点和按摩理论。",

        vocabulary: "专业词汇",
        vocabularyDesc:
            "掌握按摩领域的重要专业术语和定义。",

        wrongQuestions: "错题中心",
        wrongQuestionsDesc:
            "复习做错的题目，针对薄弱知识点进行强化。",

        welcomeBack: "欢迎回来，",
        keepBuilding: "继续巩固并提升你的知识",
        myAccount: "我的账户",
        logout: "退出登录",

        currentAccess: "当前权限",
        questionsUsed: "已使用题目",
        questionsRemaining: "剩余题目",
        membershipStatus: "会员状态",

        superUser: "超级用户",
        premiumTrial: "高级会员试用",
        premium: "高级会员",
        free: "免费版",

        monthlyPlan: "月度计划",
        quarterlyPlan: "季度计划",

        premiumAccess: "高级会员权限",
        ofFreeQuestions: "共 50 道免费题目",

        unlimited: "无限",
        fullQuestionBank: "完整题库",
        freeAccess: "免费权限",

        permanentAccess: "永久权限",
        paymentIssue: "付款异常",
        trialActive: "试用中",
        cancellationScheduled: "已安排取消",
        active: "有效",
        ended: "已结束",
        loading: "加载中...",

        fullPremiumAccess: "完整高级会员权限",
        trialEnds: "试用期结束于 {date}",
        accessUntil: "权限有效至 {date}",
        renewsOn: "续费日期 {date}",
        updatePaymentMethod: "请更新付款方式",
        upgradeAnytime: "可随时升级",
        stayConsistent: "并保持稳定的学习节奏。",

        appTitle: "按摩考试学习与练习平台",
        appTagline: "高效学习，充分练习，自信通过考试。",
        studyPractice: "学习与练习",
        studyPracticeDesc: "为你提供备考、复习和巩固考试知识所需的学习工具。",

        continueEducation: "继续学习",
        continueEducationDesc: "进一步巩固解剖学、病理学、职业道德和专业实践等核心知识。",

        structuredStudyMaterials: "系统化学习资料",
        examStrategyReview: "考试策略与复习",
        anatomyRefreshers: "解剖学与生理学复习",
        ethicsProfessionalConcepts: "职业道德与专业知识",

        goToLearningCenter: "进入学习中心",

        buildKnowledge: "积累知识。",
        buildConfidence: "建立信心。",
        learnAnyDevice: "使用任何设备，按照自己的节奏学习。",

        advanceCareer: "提升你的职业发展",
        ceProfessionalDesc:
        "为按摩专业人士提供的继续教育课程。",
        browseCeCourses: "浏览继续教育课程",
        viewCourse: "查看课程",
        mostPopular: "最受欢迎",

        comingSoon: "即将推出",
        ceCoursesComingSoon: "继续教育课程即将推出",
        ceComingSoonDesc:
        "在线完成高质量的继续教育课程，并向经验丰富的按摩治疗专业教师学习。",

        onlineLearning: "100% 在线学习",
        onlineLearningDesc:
        "随时随地，按照自己的节奏学习。",

        continuingEducation: "继续教育",
        continuingEducationDesc:
        "课程旨在满足按摩执照续期的继续教育需求，具体适用情况以您所在州的执照管理机构要求为准。",

        experiencedInstructors: "经验丰富的教师",
        experiencedInstructorsDesc:
        "向经验丰富的按摩治疗专业人士和教育工作者学习。",

        ceComingSoonFooter:
        "我们正在开发实用、高质量的继续教育课程，为你的职业发展和继续教育需求提供支持。",

        deepTissueCourse: "深层组织按摩技术",
        deepTissueCourseDesc:
        "学习针对深层肌肉紧张的进阶技术，提升按摩服务效果。",

        anatomyCourse: "解剖学与生理学复习",
        anatomyCourseDesc:
        "为按摩治疗师和考试备考提供核心解剖学知识复习。",

        painManagementCourse: "疼痛管理策略",
        painManagementCourseDesc:
        "学习以循证方法进行疼痛缓解、客户护理和治疗方案规划。",

        ceHours: "{count} CE 学时",

        examFocused: "专注执照考试",
        examFocusedDesc: "专为按摩执照考试备考而设计",

        structuredLearning: "系统化学习",
        structuredLearningDesc: "先掌握知识概念，再通过练习检验自己",

        trackProgress: "追踪学习进度",
        trackProgressDesc: "查看学习表现并发现薄弱知识点",

        anywhereAnytime: "随时随地学习",
        anywhereAnytimeDesc: "按照自己的时间安排进行学习",
    },

    practice: {
      center: "练习中心",
      readinessTitle: "提升你的 MBLEx 应试能力",
      readinessDesc:
        "通过个性化练习智能备考，或针对你希望加强的特定科目进行专项练习。",
      back: "返回",

      recommended: "推荐",
      smartPractice: "智能练习",
      smartPracticeDesc:
        "根据你的学习表现自动调整内容的个性化练习模式。",
      tenQuestionsPerRound: "每轮 10 道题",
      focusesWeakAreas: "重点练习你的薄弱知识点",
      prioritizesReview: "优先安排需要复习的题目",
      adjustsDifficulty: "自动调整题目难度",

      currentRound: "当前练习",
      unfinishedRound:
        "你有一轮尚未完成的智能练习。",
      continueSmartPractice: "继续智能练习",
      startSmartPractice: "开始智能练习",
      startNewRound: "开始新一轮",

      practiceBySubject: "按科目练习",
      practiceBySubjectDesc:
        "选择你希望复习和加强的具体内容。",
      reviewAfterClass: "课后复习学习内容",
      prepareQuizzesExams: "准备测验和考试",
      targetWeakSubject: "针对薄弱科目进行强化",
      practiceIndividualTopics: "按具体知识点进行练习",
      chooseSubject: "选择科目",

      howSmartPracticeWorks: "智能练习如何运作",
      howSmartPracticeWorksDesc:
        "智能练习会根据你的答题表现、知识掌握程度、复习计划和题目难度生成每一轮练习。完成一轮 10 道题后，下一组题目会根据你的最新表现自动调整。",

      startNewRoundTitle: "开始新一轮练习？",
      startNewRoundWarning:
        "你当前还有一轮尚未完成的智能练习。开始新一轮将放弃当前进度，并生成一组新的自适应练习题。",
      continueCurrentRound: "否，继续当前练习",
      confirmStartNewRound: "是，开始新一轮",

      practiceQuestions: "练习题",
      questionProgress: "第 {current} 题，共 {total} 题",

      mblExEnglishNoteTitle: "MBLEx 考试提示",
      mblExEnglishNote:
        "MBLEx 考试使用英文，因此练习题和答案选项将保持英文显示。答题后，你可以使用 AI Explanation，以你选择的语言查看题目翻译和详细解析。",

      loadingPracticeQuestions: "正在加载练习题...",
      noPracticeQuestion: "未找到练习题。",
      checkingAnswer: "正在检查答案...",

      correct: "回答正确！",
      incorrect: "回答错误",
      correctAnswer: "正确答案：",

      needMoreExplanation: "需要进一步解析？",
      aiTutorDesc:
        "使用 AI Tutor 查看题目翻译，并获得这道题及正确答案的详细解析。",

      explainEnglish: "用英文解析",
      explainChinese: "用中文解析",
      explainSpanish: "用西班牙语解析",
      explainRussian: "用俄语解析",
      loadingExplanation: "加载中...",

      aiExplanation: "AI 详细解析",
      source: "来源：",
      explanationHelpful: "这个解析对你有帮助吗？",
      helpful: "有帮助",
      notHelpful: "没有帮助",
      savingFeedback: "正在保存反馈...",
      thanksFeedback: "感谢你的反馈。",

      previous: "上一题",
      next: "下一题",
      finishRound: "完成本轮练习",

      loadingSubjects: "正在加载科目...",
      noSubjectsFound: "未找到科目。",

      topics: "主题",
      chooseTopicDesc:
        "选择一个主题进行练习。如果你已有未完成的练习轮次，可以从上次停止的位置继续。",
      loadingTopics: "正在加载主题...",
      noTopicsFound: "该科目下未找到主题。",
      roundInProgress: "练习进行中",
      questionsCompleted: "题已完成",
      continuePractice: "继续练习",
      startPractice: "开始练习",
      subjectRoundWarningBefore:
        "你当前有一个尚未完成的练习轮次，主题为",
      subjectRoundWarningAfter:
        "开始新一轮练习将放弃当前进度，并生成一组新的自适应练习题。",
    },

    wrongQuestion: {
      title: "错题",
      center: "错题中心",
      loading: "正在加载你的错题...",
      heroTitle: "把错误转化为掌握",
      heroDesc:
        "答错的题目会自动保存。你可以在复习时间到期时进行复习，也可以随时练习自己的薄弱题目。",

      questionsMissed: "错题数量",
      needPractice: "需要练习",
      dueNow: "现在需复习",
      mastered: "已掌握",
      totalIncorrectAttempts: "累计答错次数",

      noWrongQuestions: "目前没有错题",
      noWrongQuestionsDesc:
        "练习过程中答错的题目会自动出现在这里。",

      recommended: "推荐",
      reviewDueQuestions: "复习到期错题",
      reviewDueDesc:
        "按照你的个性化复习计划进行学习。这些是系统认为你现在最应该复习的题目。",
      reviewDueFeature1: "在题目到达复习时间时进行复习",
      reviewDueFeature2: "采用间隔重复学习",
      reviewDueFeature3: "优先关注当前最需要加强的内容",
      reviewDueFeature4: "帮助减少遗忘",
      questionsReadyNow: "道题现在可以复习",
      questionReadyNow: "道题现在可以复习",
      caughtUp: "目前没有需要复习的题目",
      startDueReview: "开始到期复习",
      nothingDue: "当前没有到期题目",
      dueQuestionsPerRound: "每轮最多复习 10 道到期题目",

      practiceWrongQuestions: "练习错题",
      practiceWrongDesc:
        "随时练习尚未掌握的错题，即使这些题目还没有到计划复习时间。",
      practiceFeature1: "随时开始练习",
      practiceFeature2: "专注于你曾经答错的题目",
      practiceFeature3: "每轮最多 10 道题",
      practiceFeature4: "答对仍会提高题目掌握度",
      questionsNeedPractice: "道题仍需练习",
      questionNeedPractice: "道题仍需练习",
      noActiveWrongQuestions: "目前没有需要练习的错题",
      practiceBeforeDue: "即使尚未到复习时间也可以练习",

      whichChoose: "我应该选择哪一种？",
      whichChooseBefore:
        "按照你的个性化复习计划进行，是日常规律学习的推荐方式。",
      whichChooseAfter:
        "允许你随时练习薄弱题目，即使系统还没有安排这些题目进行复习。",

      howItWorks: "错题系统如何运作",
      step1: "第 1 步",
      step1Title: "答错一道题",
      step1Desc:
        "任何答错的题目都会自动加入错题中心。",
      step2: "第 2 步",
      step2Title: "定期复习",
      step2Desc:
        "系统会根据你对每道题的掌握情况安排未来的复习时间。",
      step3: "第 3 步",
      step3Title: "逐步掌握",
      step3Desc:
        "答对会提高掌握度。如果再次答错，该题会继续保留在练习中。",
      step4: "第 4 步",
      step4Title: "掌握题目",
      step4Desc:
        "连续 3 次答对后，该题将进入“已掌握”状态。",
    },

    learningCenter: {
      title: "学习中心",
      subtitle: "按单元和主题学习 MBLEx 核心知识。",
      backHome: "返回首页",
      loadingUnits: "正在加载学习单元...",
      unit: "单元",
      defaultUnitDescription: "MBLEx 学习单元",
      startLearning: "开始学习",
    },

    learningUnit: {
      unit: "单元",
      back: "返回",
      loadingTopics: "正在加载主题...",
      studyTopic: "学习主题",
    },

    learningTopic: {
      topic: "主题",
      back: "返回",
      partsReviewed: "已复习 {reviewed} / {total} 个部分",
      complete: "完成",
      learningContent: "学习内容",
      noContent: "暂无该主题的学习内容。",
      reviewed: "已复习",
      undo: "撤销",
      markReviewed: "标记为已复习",
      practice: "练习",
      noExercises: "该主题暂时没有练习题。",
    },

    account: {
      backToHome: "返回首页",
      title: "我的账户",
      subtitle: "管理你的账户、订阅和学习权限。",

      account: "账户",
      profile: "个人资料",

      subscription: "订阅",
      currentPlan: "当前计划",
      loading: "加载中...",

      superUserPremium: "超级用户高级权限",
      premiumTrial: "高级会员试用",
      premiumMonthly: "高级会员月度计划",
      premiumQuarterly: "高级会员季度计划",
      premium: "高级会员",
      freePlan: "免费计划",

      permanentAccess: "永久权限",
      threeDayFreeTrial: "3 天免费试用",
      perMonthPrice: "$21.99 / 月",
      perThreeMonthsPrice: "$59.97 / 3 个月",
      freePrice: "$0",

      active: "有效",
      paymentIssue: "付款异常",
      trialActive: "试用中",
      cancellationScheduled: "已安排取消",
      ended: "已结束",
      free: "免费",

      permanentPremiumDesc: "你拥有永久高级会员权限。",
      trialEndsOn: "你的免费试用将于 {date} 结束。",
      premiumTrialActive: "你的高级会员试用目前有效。",
      paymentPaused:
        "由于付款未能成功完成，你的高级会员权限目前已暂时暂停。",
      subscriptionEndsOn:
        "你的订阅计划将于 {date} 结束。在此日期之前，你仍可继续使用高级会员权限。",
      subscriptionCancellationScheduled: "你的订阅已安排取消。",
      subscriptionRenewsOn: "你的订阅将于 {date} 自动续费。",
      previousSubscriptionEnded:
        "你之前的高级会员订阅已结束，但你的学习进度仍会保留。",
      usingFreePlan: "你目前正在使用免费计划。",

      updatePaymentMethod: "更新付款方式",
      manageSubscription: "管理订阅",

      plan: "计划",
      status: "状态",
      billing: "计费方式",
      trialEnds: "试用结束日期",
      accessUntil: "权限有效至",
      nextBillingDate: "下次计费日期",

      notApplicable: "不适用",
      trial: "试用",
      monthly: "按月",
      quarterly: "按季度",
      permanent: "永久",

      learningAccess: "学习权限",
      yourAccess: "你的学习权限",

      practiceQuestions: "练习题",
      unlimited: "无限",
      remaining: "剩余 {count} 道",
      fullQuestionBankAccess: "可使用完整题库",
      freeQuestionsUsed: "已使用 {used} / {limit} 道免费题目",

      wrongQuestions: "错题中心",
      included: "已包含",
      wrongQuestionsDesc: "复习之前答错的题目。",

      learningCenter: "学习中心",
      unlocked: "已解锁",
      premiumAccess: "高级会员",
      learningCenterDesc: "系统化学习资料和课程内容。",

      vocabulary: "专业词汇",
      vocabularyDesc: "学习、复习和练习按摩专业词汇。",

      premiumLabel: "高级会员",
      upgradeToPremium: "升级至高级会员",
      upgradeDesc:
        "解锁完整题库、学习中心、专业词汇以及高级会员学习功能。",

      monthlyPlan: "月度计划",
      quarterlyPlan: "季度计划",
      perMonth: "每月",
      everyThreeMonths: "每 3 个月",
      equivalentMonthly: "相当于每月 $19.99",

      fullPremiumAccess: "完整高级会员权限",
      unlimitedAI: "无限使用 AI 解析",
      cancelAnytime: "可随时取消",
      threeDayTrialEligible: "符合条件的新订阅用户可享 3 天免费试用",
      saveSixDollars: "每 3 个月节省 $6",

      startMonthly: "选择月度计划",
      startQuarterly: "选择季度计划",
      mostValuable: "最超值",

      progressSaved: "你的学习进度会始终保留",
      progressSavedDesc:
        "取消或更改订阅不会删除你的练习记录、错题记录、知识掌握进度或其他学习数据。",

      returnToHome: "返回首页",
      manualPaidAccess: "人工开通付费权限",
      manualPaidAccessDesc:
        "您的 Premium 权限由 ACE Massage Hub 直接开通，有效期至 {date}。",
      noAutoRenewal: "不会自动续费",
      noAutoRenewalDesc:
        "此方案不会自动续费或自动扣款。",
      paymentSource: "付款来源",
      manualPayment: "线下付款",
      renewManualAccess: "续费 Premium 权限",
      renewManualAccessDesc:
        "如需续费或延长使用期限，请联系 ACE Massage Hub。",
      contactForRenewal: "续费联系方式",
      address: "地址",
      phone: "电话",
      wechat: "微信",
      email: "邮箱",

      otherPaymentOptions: "其他付款方式",
      preferAnotherPaymentMethod: "想使用其他付款方式？",
      manualPaymentAvailable:
        "我们也支持人工付款。您可以联系 ACE Massage Hub，通过现金、Zelle、Venmo、PayPal、银行转账或支票购买 Premium 高级会员。",
      manualPaymentNoAutoRenew:
        "人工付款方案不会自动续费或自动扣款。",
      acceptedPaymentMethods: "支持：现金、Zelle、Venmo、PayPal、银行转账、支票",
    },

    footer: {
        copyright: "© 2026 Massage Exam Practice App. 保留所有权利。",
        terms: "使用条款",
        privacy: "隐私政策",
        contact: "联系我们",
    },
  },

  es: {
    language: {
      label: "Idioma",
      selectPrompt: "Selecciona tu idioma:",
      english: "English",
      chinese: "中文",
      spanish: "Español",
      russian: "Русский",
    },

    login: {
      brand: "ACE Massage Hub",
      headline: "Prepárate mejor. Afronta el MBLEx con confianza.",
      subtitle:
        "Una plataforma completa de preparación para el MBLEx con simulación realista del examen, aprendizaje adaptativo, estudio por temas y explicaciones multilingües con IA.",

      featureExam: "Simulación realista del examen MBLEx",
      featureExamDesc:
        "Practica con preguntas de estilo MBLEx diseñadas para prepararte para la experiencia real del examen.",

      featureAdaptive: "Aprendizaje adaptativo",
      featureAdaptiveDesc:
        "La práctica se adapta a tu progreso para ayudarte a concentrarte en las áreas que más necesitas mejorar.",

      featureTopics: "Aprendizaje por temas",
      featureTopicsDesc:
        "Refuerza áreas específicas de conocimiento e identifica tus temas más débiles antes del examen.",

      featureAI: "Explicaciones de IA en tu idioma",
      featureAIDesc:
        "Comprende preguntas difíciles con explicaciones de IA disponibles en inglés, chino, español y ruso.",

      studentLogin: "Inicio de sesión",
      loginSubtitle:
        "Inicia sesión para acceder a tus bancos de preguntas y herramientas de estudio.",
      email: "Correo electrónico",
      password: "Contraseña",
      loginButton: "Iniciar sesión",
      forgotPassword: "¿Olvidaste tu contraseña?",
      createAccount: "Crear cuenta",
      noAccount: "¿Eres nuevo?",

      studentSignup: "Registro de estudiante",
      signupSubtitle:
        "Crea tu cuenta de estudiante para acceder a la plataforma de estudio.",
      fullName: "Nombre completo",
      username: "Nombre de usuario",
      signupButton: "Registrarse",
      alreadyHaveAccount: "¿Ya tienes una cuenta? Inicia sesión",

      resetPassword: "Restablecer contraseña",
      resetPasswordSubtitle: "Introduce tu nueva contraseña.",
      newPassword: "Nueva contraseña",
      updatePassword: "Actualizar contraseña",

      welcomeBack: "Bienvenido de nuevo",
      superUserAccess: "Acceso de SuperUsuario",
      adminDashboard: "Panel de administración",
      logout: "Cerrar sesión",
      security: "Tu información está protegida de forma segura.",
    },

    home: {
        practiceQuestions: "Preguntas de práctica",
        practiceQuestionsDesc:
            "Gana confianza con preguntas de práctica realistas al estilo MBLEx.",

        learningCenter: "Centro de aprendizaje",
        learningCenterDesc:
            "Estudia apuntes estructurados, conceptos clave y teoría del masaje.",

        vocabulary: "Vocabulario",
        vocabularyDesc:
            "Domina la terminología y las definiciones esenciales del masaje.",

        wrongQuestions: "Preguntas incorrectas",
        wrongQuestionsDesc:
            "Repasa las preguntas que fallaste y refuerza tus áreas más débiles.",

        welcomeBack: "Bienvenido de nuevo,",
        keepBuilding: "Sigue fortaleciendo tus conocimientos",
        myAccount: "Mi cuenta",
        logout: "Cerrar sesión",

        currentAccess: "Acceso actual",
        questionsUsed: "Preguntas utilizadas",
        questionsRemaining: "Preguntas restantes",
        membershipStatus: "Estado de membresía",

        superUser: "Superusuario",
        premiumTrial: "Prueba Premium",
        premium: "Premium",
        free: "Gratis",

        monthlyPlan: "Plan mensual",
        quarterlyPlan: "Plan trimestral",

        premiumAccess: "Acceso Premium",
        ofFreeQuestions: "de 50 preguntas gratuitas",

        unlimited: "Ilimitadas",
        fullQuestionBank: "Banco completo de preguntas",
        freeAccess: "Acceso gratuito",

        permanentAccess: "Acceso permanente",
        paymentIssue: "Problema de pago",
        trialActive: "Prueba activa",
        cancellationScheduled: "Cancelación programada",
        active: "Activo",
        ended: "Finalizado",
        loading: "Cargando...",

        fullPremiumAccess: "Acceso Premium completo",
        trialEnds: "La prueba termina el {date}",
        accessUntil: "Acceso hasta {date}",
        renewsOn: "Se renueva el {date}",
        updatePaymentMethod: "Actualiza el método de pago",
        upgradeAnytime: "Puedes actualizar en cualquier momento",
        stayConsistent: "y mantén la constancia.",

        appTitle: "Aplicación de práctica para el examen de masaje",
        appTagline: "Estudia mejor. Practica más. Aprueba con confianza.",
        studyPractice: "Estudio y práctica",
        studyPracticeDesc: "Todo lo que necesitas para prepararte, repasar y reforzar tus conocimientos para el examen.",

        continueEducation: "Continúa tu formación",
        continueEducationDesc:
        "Refuerza tus conocimientos de anatomía, patología, ética y práctica profesional.",

        structuredStudyMaterials: "Materiales de estudio estructurados",
        examStrategyReview: "Estrategias de examen y repaso",
        anatomyRefreshers: "Repaso de anatomía y fisiología",
        ethicsProfessionalConcepts: "Ética y conceptos profesionales",

        goToLearningCenter: "Ir al centro de aprendizaje",

        buildKnowledge: "Amplía tus conocimientos.",
        buildConfidence: "Aumenta tu confianza.",
        learnAnyDevice: "Aprende a tu propio ritmo desde cualquier dispositivo.",

        advanceCareer: "Impulsa tu carrera profesional",
        ceProfessionalDesc:
        "Cursos de educación continua para profesionales del masaje.",
        browseCeCourses: "Explorar cursos de educación continua",
        viewCourse: "Ver curso",
        mostPopular: "Más popular",

        comingSoon: "PRÓXIMAMENTE",
        ceCoursesComingSoon: "CURSOS DE EDUCACIÓN CONTINUA PRÓXIMAMENTE",
        ceComingSoonDesc:
        "Completa cursos de educación continua de alta calidad en línea y aprende de instructores experimentados en terapia de masaje.",

        onlineLearning: "100% en línea",
        onlineLearningDesc:
        "Aprende a tu propio ritmo desde cualquier lugar.",

        continuingEducation: "Educación continua",
        continuingEducationDesc:
        "Diseñado para apoyar los requisitos de renovación de la licencia de masaje cuando sea aceptado por la junta de licencias de tu estado.",

        experiencedInstructors: "Instructores experimentados",
        experiencedInstructorsDesc:
        "Aprende de profesionales y educadores con experiencia en terapia de masaje.",

        ceComingSoonFooter:
        "Estamos desarrollando cursos de educación continua prácticos y de alta calidad para apoyar tu crecimiento profesional y tus necesidades de formación continua.",

        deepTissueCourse: "Técnicas de masaje de tejido profundo",
        deepTissueCourseDesc:
        "Técnicas avanzadas para tratar la tensión muscular profunda y mejorar los resultados del cliente.",

        anatomyCourse: "Repaso de anatomía y fisiología",
        anatomyCourseDesc:
        "Repaso esencial de anatomía para terapeutas de masaje y preparación para el examen.",

        painManagementCourse: "Estrategias para el manejo del dolor",
        painManagementCourseDesc:
        "Enfoques basados en evidencia para el alivio del dolor, la atención al cliente y la planificación del tratamiento.",

        ceHours: "{count} horas CE",

        examFocused: "Enfocado en el examen",
        examFocusedDesc: "Diseñado para preparar el examen de licencia",

        structuredLearning: "Aprendizaje estructurado",
        structuredLearningDesc: "Aprende los conceptos antes de ponerlos a prueba",

        trackProgress: "Seguimiento del progreso",
        trackProgressDesc: "Revisa tu rendimiento y tus áreas más débiles",

        anywhereAnytime: "En cualquier momento y lugar",
        anywhereAnytimeDesc: "Estudia según tu propio horario",
    },

    practice: {
      center: "CENTRO DE PRÁCTICA",
      readinessTitle: "Mejora tu preparación para el MBLEx",
      readinessDesc:
        "Practica de forma más inteligente con preguntas personalizadas o concéntrate en una materia específica que quieras reforzar.",
      back: "Volver",

      recommended: "RECOMENDADO",
      smartPractice: "Práctica inteligente",
      smartPracticeDesc:
        "Práctica personalizada que se adapta automáticamente a tu rendimiento.",
      tenQuestionsPerRound: "10 preguntas por ronda",
      focusesWeakAreas: "Se enfoca en tus áreas más débiles",
      prioritizesReview: "Prioriza las preguntas que debes repasar",
      adjustsDifficulty: "La dificultad se ajusta automáticamente",

      currentRound: "Ronda actual",
      unfinishedRound:
        "Tienes una ronda de práctica inteligente sin terminar.",
      continueSmartPractice: "Continuar práctica inteligente",
      startSmartPractice: "Iniciar práctica inteligente",
      startNewRound: "Iniciar nueva ronda",

      practiceBySubject: "Práctica por materia",
      practiceBySubjectDesc:
        "Elige exactamente lo que quieres repasar y reforzar.",
      reviewAfterClass: "Repasa el material después de clase",
      prepareQuizzesExams: "Prepárate para pruebas y exámenes",
      targetWeakSubject: "Refuerza una materia específica",
      practiceIndividualTopics: "Practica temas individuales",
      chooseSubject: "Elegir una materia",

      howSmartPracticeWorks: "Cómo funciona la práctica inteligente",
      howSmartPracticeWorksDesc:
        "La práctica inteligente utiliza tu rendimiento, dominio, programa de repaso y dificultad de las preguntas para crear cada ronda. Completa una ronda de 10 preguntas y el siguiente conjunto se adaptará automáticamente a tus resultados más recientes.",

      startNewRoundTitle: "¿Iniciar una nueva ronda?",
      startNewRoundWarning:
        "Actualmente tienes una ronda de práctica inteligente sin terminar. Al iniciar una nueva ronda, abandonarás tu progreso actual y se creará un nuevo conjunto de preguntas adaptativas.",
      continueCurrentRound: "No, continuar la ronda actual",
      confirmStartNewRound: "Sí, iniciar nueva ronda",

      practiceQuestions: "Preguntas de práctica",
      questionProgress: "Pregunta {current} de {total}",

      mblExEnglishNoteTitle: "Nota sobre el examen MBLEx",
      mblExEnglishNote:
        "El examen MBLEx se administra en inglés, por lo que las preguntas de práctica y las opciones de respuesta se muestran en inglés. Después de responder, puedes usar AI Explanation para ver una traducción y una explicación detallada en el idioma que hayas seleccionado.",

      loadingPracticeQuestions: "Cargando preguntas de práctica...",
      noPracticeQuestion: "No se encontró ninguna pregunta de práctica.",
      checkingAnswer: "Comprobando respuesta...",

      correct: "¡Correcto!",
      incorrect: "Incorrecto",
      correctAnswer: "Respuesta correcta:",

      needMoreExplanation: "¿Necesitas más explicación?",
      aiTutorDesc:
        "Usa el tutor de IA para ver una traducción de la pregunta y una explicación detallada de la respuesta.",

      explainEnglish: "Explicar en inglés",
      explainChinese: "Explicar en chino",
      explainSpanish: "Explicar en español",
      explainRussian: "Explicar en ruso",
      loadingExplanation: "Cargando...",

      aiExplanation: "Explicación de IA",
      source: "Fuente:",
      explanationHelpful: "¿Te resultó útil esta explicación?",
      helpful: "Útil",
      notHelpful: "No fue útil",
      savingFeedback: "Guardando comentarios...",
      thanksFeedback: "Gracias por tus comentarios.",

      previous: "Anterior",
      next: "Siguiente",
      finishRound: "Finalizar ronda",

      loadingSubjects: "Cargando materias...",
      noSubjectsFound: "No se encontraron materias.",

      topics: "Temas",
      chooseTopicDesc:
        "Elige un tema para practicar. Si ya tienes una ronda sin terminar, puedes continuar desde donde la dejaste.",
      loadingTopics: "Cargando temas...",
      noTopicsFound: "No se encontraron temas para esta materia.",
      roundInProgress: "Ronda en curso",
      questionsCompleted: "preguntas completadas",
      continuePractice: "Continuar práctica",
      startPractice: "Iniciar práctica",
      subjectRoundWarningBefore:
        "Actualmente tienes una ronda de práctica sin terminar para",
      subjectRoundWarningAfter:
        "Iniciar una nueva ronda abandonará tu progreso actual y generará un nuevo conjunto adaptativo de preguntas.",
    },

    wrongQuestion: {
      title: "Preguntas incorrectas",
      center: "Centro de preguntas incorrectas",
      loading: "Cargando tus preguntas incorrectas...",
      heroTitle: "Convierte los errores en dominio",
      heroDesc:
        "Las preguntas que respondes incorrectamente se guardan automáticamente. Repásalas cuando corresponda o practica tus preguntas débiles en cualquier momento.",

      questionsMissed: "Preguntas falladas",
      needPractice: "Necesitan práctica",
      dueNow: "Para repasar ahora",
      mastered: "Dominadas",
      totalIncorrectAttempts: "Total de intentos incorrectos",

      noWrongQuestions: "Aún no hay preguntas incorrectas",
      noWrongQuestionsDesc:
        "Las preguntas que respondas incorrectamente durante la práctica aparecerán automáticamente aquí.",

      recommended: "RECOMENDADO",
      reviewDueQuestions: "Repasar preguntas programadas",
      reviewDueDesc:
        "Sigue tu programa de repaso personalizado. Estas son las preguntas que la aplicación considera que debes repasar ahora.",
      reviewDueFeature1: "Repasa las preguntas cuando corresponde",
      reviewDueFeature2: "Utiliza repetición espaciada",
      reviewDueFeature3: "Se centra en lo que necesita atención ahora",
      reviewDueFeature4: "Ayuda a prevenir el olvido",
      questionsReadyNow: "preguntas listas para repasar",
      questionReadyNow: "pregunta lista para repasar",
      caughtUp: "Estás al día por ahora",
      startDueReview: "Iniciar repaso",
      nothingDue: "Nada pendiente ahora",
      dueQuestionsPerRound: "Hasta 10 preguntas programadas por ronda",

      practiceWrongQuestions: "Practicar preguntas incorrectas",
      practiceWrongDesc:
        "Practica tus preguntas incorrectas aún no dominadas en cualquier momento, incluso si todavía no están programadas para repaso.",
      practiceFeature1: "Practica cuando quieras",
      practiceFeature2: "Concéntrate en las preguntas que has fallado",
      practiceFeature3: "Hasta 10 preguntas por ronda",
      practiceFeature4: "Las respuestas correctas siguen aumentando el dominio",
      questionsNeedPractice: "preguntas aún necesitan práctica",
      questionNeedPractice: "pregunta aún necesita práctica",
      noActiveWrongQuestions: "No hay preguntas incorrectas activas",
      practiceBeforeDue: "Practica incluso antes de la fecha de repaso",

      whichChoose: "¿Cuál debo elegir?",
      whichChooseBefore:
        "sigue tu programa de repaso personalizado y es la opción recomendada para el estudio diario regular.",
      whichChooseAfter:
        "te permite estudiar tus preguntas débiles en cualquier momento, incluso antes de que la aplicación indique que debes repasarlas.",

      howItWorks: "Cómo funcionan las preguntas incorrectas",
      step1: "PASO 1",
      step1Title: "Falla una pregunta",
      step1Desc:
        "Cualquier pregunta que respondas incorrectamente se añade automáticamente a Preguntas incorrectas.",
      step2: "PASO 2",
      step2Title: "Repasa con el tiempo",
      step2Desc:
        "La aplicación programa futuros repasos según tu progreso con cada pregunta.",
      step3: "PASO 3",
      step3Title: "Desarrolla el dominio",
      step3Desc:
        "Las respuestas correctas aumentan tu dominio. Si vuelves a fallar la pregunta, permanece en la práctica activa.",
      step4: "PASO 4",
      step4Title: "Domina la pregunta",
      step4Desc:
        "Responde correctamente 3 veces seguidas y la pregunta pasará a Dominadas.",
    },

    learningCenter: {
      title: "Centro de aprendizaje",
      subtitle: "Estudia los conceptos del MBLEx por unidad y tema.",
      backHome: "Volver al inicio",
      loadingUnits: "Cargando unidades de aprendizaje...",
      unit: "Unidad",
      defaultUnitDescription: "Unidad de aprendizaje del MBLEx",
      startLearning: "Comenzar a estudiar",
    },

    learningUnit: {
      unit: "Unidad",
      back: "Volver",
      loadingTopics: "Cargando temas...",
      studyTopic: "Estudiar tema",
    },

    learningTopic: {
      topic: "Tema",
      back: "Volver",
      partsReviewed: "{reviewed} de {total} partes revisadas",
      complete: "completado",
      learningContent: "Contenido de aprendizaje",
      noContent: "No se encontró contenido para este tema.",
      reviewed: "Revisado",
      undo: "Deshacer",
      markReviewed: "Marcar como revisado",
      practice: "Práctica",
      noExercises: "Todavía no hay ejercicios para este tema.",
    },

    account: {
      backToHome: "Volver al inicio",
      title: "Mi cuenta",
      subtitle: "Administra tu cuenta, suscripción y acceso al aprendizaje.",

      account: "CUENTA",
      profile: "Perfil",

      subscription: "SUSCRIPCIÓN",
      currentPlan: "Plan actual",
      loading: "Cargando...",

      superUserPremium: "Premium SuperUsuario",
      premiumTrial: "Prueba Premium",
      premiumMonthly: "Premium mensual",
      premiumQuarterly: "Premium trimestral",
      premium: "Premium",
      freePlan: "Plan gratuito",

      permanentAccess: "Acceso permanente",
      threeDayFreeTrial: "Prueba gratuita de 3 días",
      perMonthPrice: "$21.99 / mes",
      perThreeMonthsPrice: "$59.97 / 3 meses",
      freePrice: "$0",

      active: "Activo",
      paymentIssue: "Problema de pago",
      trialActive: "Prueba activa",
      cancellationScheduled: "Cancelación programada",
      ended: "Finalizado",
      free: "Gratis",

      permanentPremiumDesc: "Tienes acceso Premium permanente.",
      trialEndsOn: "Tu prueba gratuita termina el {date}.",
      premiumTrialActive: "Tu prueba Premium está activa actualmente.",
      paymentPaused:
        "Tu acceso Premium está temporalmente suspendido porque no se pudo completar el pago.",
      subscriptionEndsOn:
        "Tu suscripción está programada para finalizar el {date}. Mantendrás el acceso Premium hasta entonces.",
      subscriptionCancellationScheduled:
        "Tu suscripción está programada para cancelarse.",
      subscriptionRenewsOn: "Tu suscripción se renovará el {date}.",
      previousSubscriptionEnded:
        "Tu suscripción Premium anterior ha finalizado. Tu progreso de aprendizaje sigue guardado.",
      usingFreePlan: "Actualmente estás usando el plan gratuito.",

      updatePaymentMethod: "Actualizar método de pago",
      manageSubscription: "Administrar suscripción",

      plan: "Plan",
      status: "Estado",
      billing: "Facturación",
      trialEnds: "Fin de la prueba",
      accessUntil: "Acceso hasta",
      nextBillingDate: "Próxima fecha de facturación",

      notApplicable: "No aplicable",
      trial: "Prueba",
      monthly: "Mensual",
      quarterly: "Trimestral",
      permanent: "Permanente",

      learningAccess: "ACCESO DE APRENDIZAJE",
      yourAccess: "Tu acceso",

      practiceQuestions: "Preguntas de práctica",
      unlimited: "Ilimitadas",
      remaining: "{count} restantes",
      fullQuestionBankAccess: "Acceso al banco completo de preguntas",
      freeQuestionsUsed: "{used} de {limit} preguntas gratuitas utilizadas",

      wrongQuestions: "Preguntas incorrectas",
      included: "Incluido",
      wrongQuestionsDesc: "Repasa las preguntas que respondiste incorrectamente.",

      learningCenter: "Centro de aprendizaje",
      unlocked: "Desbloqueado",
      premiumAccess: "Premium",
      learningCenterDesc: "Materiales de aprendizaje y contenido de estudio estructurados.",

      vocabulary: "Vocabulario",
      vocabularyDesc: "Estudio, repaso y práctica de vocabulario.",

      premiumLabel: "PREMIUM",
      upgradeToPremium: "Actualizar a Premium",
      upgradeDesc:
        "Desbloquea el banco completo de preguntas, el Centro de aprendizaje, Vocabulario y las funciones de estudio Premium.",

      monthlyPlan: "Mensual",
      quarterlyPlan: "Trimestral",
      perMonth: "por mes",
      everyThreeMonths: "cada 3 meses",
      equivalentMonthly: "Equivale a $19.99 / mes",

      fullPremiumAccess: "Acceso Premium completo",
      unlimitedAI: "Explicaciones de IA ilimitadas",
      cancelAnytime: "Cancela en cualquier momento",
      threeDayTrialEligible: "Prueba de 3 días para nuevos suscriptores elegibles",
      saveSixDollars: "Ahorra $6 cada 3 meses",

      startMonthly: "Comenzar plan mensual",
      startQuarterly: "Comenzar plan trimestral",
      mostValuable: "MEJOR VALOR",

      progressSaved: "Tu progreso siempre se guarda",
      progressSavedDesc:
        "Cancelar o cambiar tu suscripción no elimina tu historial de práctica, preguntas incorrectas, progreso de dominio ni datos de aprendizaje.",

      returnToHome: "Volver al inicio",
      manualPaidAccess: "Acceso Premium activado manualmente",
      manualPaidAccessDesc:
        "Tu acceso Premium fue activado directamente por ACE Massage Hub y permanecerá activo hasta {date}.",
      noAutoRenewal: "Sin renovación automática",
      noAutoRenewalDesc:
        "Este plan no se renueva ni se cobra automáticamente.",
      paymentSource: "Origen del pago",
      manualPayment: "Pago manual",
      renewManualAccess: "Renovar tu acceso",
      renewManualAccessDesc:
        "Para renovar o extender tu acceso, comunícate con ACE Massage Hub.",
      contactForRenewal: "Contacto para renovación",
      address: "Dirección",
      phone: "Teléfono",
      wechat: "WeChat",
      email: "Correo electrónico",

      otherPaymentOptions: "Otras formas de pago",
      preferAnotherPaymentMethod: "¿Prefieres otra forma de pago?",
      manualPaymentAvailable:
        "También aceptamos pagos manuales. Comunícate con ACE Massage Hub para comprar acceso Premium mediante efectivo, Zelle, Venmo, PayPal, transferencia bancaria o cheque.",
      manualPaymentNoAutoRenew:
        "Los planes con pago manual no se renuevan automáticamente.",
      acceptedPaymentMethods: "Aceptamos: efectivo, Zelle, Venmo, PayPal, transferencia bancaria y cheque",
    },

    footer: {
        copyright: "© 2026 Massage Exam Practice App. Todos los derechos reservados.",
        terms: "Términos de uso",
        privacy: "Política de privacidad",
        contact: "Contáctanos",
    },
  },

  ru: {
    language: {
      label: "Язык",
      selectPrompt: "Выберите язык:",
      english: "English",
      chinese: "中文",
      spanish: "Español",
      russian: "Русский",
    },

    login: {
      brand: "ACE Massage Hub",
      headline: "Готовьтесь эффективнее. Сдавайте MBLEx уверенно.",
      subtitle:
        "Комплексная платформа подготовки к MBLEx с реалистичной симуляцией экзамена, адаптивным обучением, изучением по темам и многоязычными объяснениями с помощью ИИ.",

      featureExam: "Реалистичная симуляция экзамена MBLEx",
      featureExamDesc:
        "Практикуйтесь на вопросах в формате MBLEx и заранее знакомьтесь с форматом настоящего экзамена.",

      featureAdaptive: "Адаптивное обучение",
      featureAdaptiveDesc:
        "Практика адаптируется к вашему прогрессу и помогает сосредоточиться на темах, которые требуют улучшения.",

      featureTopics: "Обучение по темам",
      featureTopicsDesc:
        "Укрепляйте знания по отдельным темам и выявляйте слабые области до экзамена.",

      featureAI: "Объяснения ИИ на вашем языке",
      featureAIDesc:
        "Получайте объяснения сложных вопросов на английском, китайском, испанском или русском языке.",

      studentLogin: "Вход для студентов",
      loginSubtitle:
        "Войдите, чтобы получить доступ к банкам вопросов и учебным инструментам.",
      email: "Электронная почта",
      password: "Пароль",
      loginButton: "Войти",
      forgotPassword: "Забыли пароль?",
      createAccount: "Создать аккаунт",
      noAccount: "Новый пользователь?",

      studentSignup: "Регистрация студента",
      signupSubtitle:
        "Создайте учетную запись студента для доступа к учебной платформе.",
      fullName: "Полное имя",
      username: "Имя пользователя",
      signupButton: "Зарегистрироваться",
      alreadyHaveAccount: "Уже есть аккаунт? Войти",

      resetPassword: "Сброс пароля",
      resetPasswordSubtitle: "Введите новый пароль.",
      newPassword: "Новый пароль",
      updatePassword: "Обновить пароль",

      welcomeBack: "С возвращением",
      superUserAccess: "Доступ SuperUser",
      adminDashboard: "Панель администратора",
      logout: "Выйти",
      security: "Ваша информация надежно защищена.",
    },

    home: {
        practiceQuestions: "Практические вопросы",
        practiceQuestionsDesc:
            "Повышайте уверенность с помощью реалистичных практических вопросов в формате MBLEx.",

        learningCenter: "Учебный центр",
        learningCenterDesc:
            "Изучайте структурированные материалы, ключевые понятия и теорию массажа.",

        vocabulary: "Терминология",
        vocabularyDesc:
            "Освойте основные термины и определения в области массажа.",

        wrongQuestions: "Ошибочные ответы",
        wrongQuestionsDesc:
            "Повторяйте вопросы, в которых вы ошиблись, и укрепляйте слабые темы.",

        welcomeBack: "С возвращением,",
        keepBuilding: "Продолжайте укреплять свои знания",
        myAccount: "Мой аккаунт",
        logout: "Выйти",

        currentAccess: "Текущий доступ",
        questionsUsed: "Использовано вопросов",
        questionsRemaining: "Осталось вопросов",
        membershipStatus: "Статус подписки",

        superUser: "Суперпользователь",
        premiumTrial: "Пробный Premium",
        premium: "Premium",
        free: "Бесплатный",

        monthlyPlan: "Ежемесячный план",
        quarterlyPlan: "Квартальный план",

        premiumAccess: "Premium-доступ",
        ofFreeQuestions: "из 50 бесплатных вопросов",

        unlimited: "Без ограничений",
        fullQuestionBank: "Полный банк вопросов",
        freeAccess: "Бесплатный доступ",

        permanentAccess: "Постоянный доступ",
        paymentIssue: "Проблема с оплатой",
        trialActive: "Пробный период активен",
        cancellationScheduled: "Отмена запланирована",
        active: "Активна",
        ended: "Завершена",
        loading: "Загрузка...",

        fullPremiumAccess: "Полный Premium-доступ",
        trialEnds: "Пробный период до {date}",
        accessUntil: "Доступ до {date}",
        renewsOn: "Продление {date}",
        updatePaymentMethod: "Обновите способ оплаты",
        upgradeAnytime: "Можно обновить тариф в любое время",
        stayConsistent: "и занимайтесь регулярно.",

        appTitle: "Подготовка к экзамену по массажу",
        appTagline: "Учитесь эффективно. Практикуйтесь больше. Сдавайте уверенно.",
        studyPractice: "Учёба и практика",
        studyPracticeDesc: "Всё необходимое для подготовки, повторения и укрепления знаний перед экзаменом.",

        continueEducation: "Продолжайте обучение",
        continueEducationDesc:
        "Укрепляйте знания по анатомии, патологии, этике и профессиональной практике.",

        structuredStudyMaterials: "Структурированные учебные материалы",
        examStrategyReview: "Стратегия экзамена и повторение",
        anatomyRefreshers: "Повторение анатомии и физиологии",
        ethicsProfessionalConcepts: "Этика и профессиональные понятия",

        goToLearningCenter: "Перейти в учебный центр",

        buildKnowledge: "Расширяйте знания.",
        buildConfidence: "Укрепляйте уверенность.",
        learnAnyDevice: "Учитесь в своём темпе с любого устройства.",

        advanceCareer: "Развивайте свою карьеру",
        ceProfessionalDesc:
        "Курсы повышения квалификации для специалистов по массажу.",
        browseCeCourses: "Просмотреть курсы",
        viewCourse: "Посмотреть курс",
        mostPopular: "Самый популярный",

        comingSoon: "СКОРО",
        ceCoursesComingSoon: "КУРСЫ ПОВЫШЕНИЯ КВАЛИФИКАЦИИ — СКОРО",
        ceComingSoonDesc:
        "Проходите качественные онлайн-курсы повышения квалификации и обучайтесь у опытных преподавателей массажной терапии.",

        onlineLearning: "100% онлайн",
        onlineLearningDesc:
        "Учитесь в своём темпе из любого места.",

        continuingEducation: "Повышение квалификации",
        continuingEducationDesc:
        "Курсы предназначены для поддержки требований по продлению лицензии массажиста, если они принимаются лицензирующим органом вашего штата.",

        experiencedInstructors: "Опытные преподаватели",
        experiencedInstructorsDesc:
        "Обучайтесь у опытных специалистов и преподавателей массажной терапии.",

        ceComingSoonFooter:
        "Мы разрабатываем практические и качественные курсы повышения квалификации для поддержки вашего профессионального развития и дальнейшего обучения.",

        deepTissueCourse: "Техники глубокотканного массажа",
        deepTissueCourseDesc:
        "Продвинутые техники для работы с глубоким мышечным напряжением и улучшения результатов для клиентов.",

        anatomyCourse: "Повторение анатомии и физиологии",
        anatomyCourseDesc:
        "Основы анатомии для специалистов по массажу и подготовки к экзамену.",

        painManagementCourse: "Стратегии управления болью",
        painManagementCourseDesc:
        "Научно обоснованные подходы к облегчению боли, работе с клиентами и планированию терапии.",

        ceHours: "{count} часов CE",

        examFocused: "Подготовка к экзамену",
        examFocusedDesc: "Создано специально для подготовки к лицензионному экзамену",

        structuredLearning: "Структурированное обучение",
        structuredLearningDesc: "Сначала изучайте материал, затем проверяйте свои знания",

        trackProgress: "Отслеживание прогресса",
        trackProgressDesc: "Анализируйте результаты и выявляйте слабые темы",

        anywhereAnytime: "В любое время и в любом месте",
        anywhereAnytimeDesc: "Занимайтесь по удобному для вас расписанию",
    },

    practice: {
      center: "ЦЕНТР ПРАКТИКИ",
      readinessTitle: "Повышайте готовность к MBLEx",
      readinessDesc:
        "Практикуйтесь эффективнее с персонализированными вопросами или сосредоточьтесь на конкретной теме, которую хотите улучшить.",
      back: "Назад",

      recommended: "РЕКОМЕНДУЕТСЯ",
      smartPractice: "Умная практика",
      smartPracticeDesc:
        "Персонализированная практика, которая автоматически адаптируется к вашим результатам.",
      tenQuestionsPerRound: "10 вопросов в каждом раунде",
      focusesWeakAreas: "Фокусируется на слабых темах",
      prioritizesReview: "Приоритет вопросам, которые пора повторить",
      adjustsDifficulty: "Сложность регулируется автоматически",

      currentRound: "Текущий раунд",
      unfinishedRound:
        "У вас есть незавершённый раунд умной практики.",
      continueSmartPractice: "Продолжить умную практику",
      startSmartPractice: "Начать умную практику",
      startNewRound: "Начать новый раунд",

      practiceBySubject: "Практика по предметам",
      practiceBySubjectDesc:
        "Выберите именно тот материал, который хотите повторить и улучшить.",
      reviewAfterClass: "Повторяйте материал после занятий",
      prepareQuizzesExams: "Готовьтесь к тестам и экзаменам",
      targetWeakSubject: "Укрепляйте знания по слабому предмету",
      practiceIndividualTopics: "Практикуйтесь по отдельным темам",
      chooseSubject: "Выбрать предмет",

      howSmartPracticeWorks: "Как работает умная практика",
      howSmartPracticeWorksDesc:
        "Умная практика использует ваши результаты, уровень освоения материала, график повторения и сложность вопросов для формирования каждого раунда. После завершения раунда из 10 вопросов следующий набор автоматически адаптируется к вашим последним результатам.",

      startNewRoundTitle: "Начать новый раунд?",
      startNewRoundWarning:
        "У вас есть незавершённый раунд умной практики. При запуске нового раунда текущий прогресс будет оставлен, а система создаст новый набор адаптивных вопросов.",
      continueCurrentRound: "Нет, продолжить текущий раунд",
      confirmStartNewRound: "Да, начать новый раунд",

      practiceQuestions: "Практические вопросы",
      questionProgress: "Вопрос {current} из {total}",

      mblExEnglishNoteTitle: "Примечание к экзамену MBLEx",
      mblExEnglishNote:
        "Экзамен MBLEx проводится на английском языке, поэтому практические вопросы и варианты ответов отображаются на английском. После ответа вы можете использовать AI Explanation, чтобы посмотреть перевод вопроса и подробное объяснение на выбранном вами языке.",

      loadingPracticeQuestions: "Загрузка практических вопросов...",
      noPracticeQuestion: "Практический вопрос не найден.",
      checkingAnswer: "Проверка ответа...",

      correct: "Правильно!",
      incorrect: "Неправильно",
      correctAnswer: "Правильный ответ:",

      needMoreExplanation: "Нужно более подробное объяснение?",
      aiTutorDesc:
        "Используйте AI Tutor, чтобы посмотреть перевод вопроса и подробное объяснение ответа.",

      explainEnglish: "Объяснить на английском",
      explainChinese: "Объяснить на китайском",
      explainSpanish: "Объяснить на испанском",
      explainRussian: "Объяснить на русском",
      loadingExplanation: "Загрузка...",

      aiExplanation: "Объяснение ИИ",
      source: "Источник:",
      explanationHelpful: "Было ли это объяснение полезным?",
      helpful: "Полезно",
      notHelpful: "Не полезно",
      savingFeedback: "Сохранение отзыва...",
      thanksFeedback: "Спасибо за ваш отзыв.",

      previous: "Предыдущий",
      next: "Следующий",
      finishRound: "Завершить раунд",

      loadingSubjects: "Загрузка предметов...",
      noSubjectsFound: "Предметы не найдены.",

      topics: "Темы",
      chooseTopicDesc:
        "Выберите тему для практики. Если у вас уже есть незавершённый раунд, вы можете продолжить с того места, где остановились.",
      loadingTopics: "Загрузка тем...",
      noTopicsFound: "Для этого предмета темы не найдены.",
      roundInProgress: "Раунд продолжается",
      questionsCompleted: "вопросов завершено",
      continuePractice: "Продолжить практику",
      startPractice: "Начать практику",
      subjectRoundWarningBefore:
        "У вас есть незавершённый практический раунд по теме",
      subjectRoundWarningAfter:
        "При запуске нового раунда текущий прогресс будет отменён и будет создан новый адаптивный набор вопросов.",
    },

    wrongQuestion: {
      title: "Ошибочные ответы",
      center: "Центр ошибочных ответов",
      loading: "Загрузка ваших ошибочных ответов...",
      heroTitle: "Превращайте ошибки в знания",
      heroDesc:
        "Вопросы, на которые вы ответили неправильно, сохраняются автоматически. Повторяйте их по расписанию или практикуйте слабые вопросы в любое время.",

      questionsMissed: "Ошибочных вопросов",
      needPractice: "Нужна практика",
      dueNow: "Пора повторить",
      mastered: "Освоено",
      totalIncorrectAttempts: "Всего неправильных попыток",

      noWrongQuestions: "Ошибочных вопросов пока нет",
      noWrongQuestionsDesc:
        "Вопросы, на которые вы ответите неправильно во время практики, автоматически появятся здесь.",

      recommended: "РЕКОМЕНДУЕТСЯ",
      reviewDueQuestions: "Повторить запланированные вопросы",
      reviewDueDesc:
        "Следуйте персональному расписанию повторения. Здесь собраны вопросы, которые приложение рекомендует повторить сейчас.",
      reviewDueFeature1: "Повторяйте вопросы в назначенное время",
      reviewDueFeature2: "Использует интервальное повторение",
      reviewDueFeature3: "Сосредоточьтесь на том, что требует внимания сейчас",
      reviewDueFeature4: "Помогает предотвратить забывание",
      questionsReadyNow: "вопросов готовы к повторению",
      questionReadyNow: "вопрос готов к повторению",
      caughtUp: "На данный момент всё повторено",
      startDueReview: "Начать повторение",
      nothingDue: "Сейчас ничего не требуется повторять",
      dueQuestionsPerRound: "До 10 запланированных вопросов за раунд",

      practiceWrongQuestions: "Практиковать ошибочные вопросы",
      practiceWrongDesc:
        "Практикуйте ещё не освоенные ошибочные вопросы в любое время, даже если срок их повторения ещё не наступил.",
      practiceFeature1: "Практикуйтесь в любое время",
      practiceFeature2: "Сосредоточьтесь на вопросах, в которых вы ошибались",
      practiceFeature3: "До 10 вопросов за раунд",
      practiceFeature4: "Правильные ответы продолжают повышать уровень освоения",
      questionsNeedPractice: "вопросов всё ещё требуют практики",
      questionNeedPractice: "вопрос всё ещё требует практики",
      noActiveWrongQuestions: "Нет активных ошибочных вопросов",
      practiceBeforeDue: "Практикуйтесь ещё до запланированного повторения",

      whichChoose: "Что выбрать?",
      whichChooseBefore:
        "следует вашему персональному расписанию повторения и рекомендуется для регулярных ежедневных занятий.",
      whichChooseAfter:
        "позволяет практиковать слабые вопросы в любое время, даже до того, как приложение назначит их повторение.",

      howItWorks: "Как работает система ошибочных вопросов",
      step1: "ШАГ 1",
      step1Title: "Ответьте неправильно",
      step1Desc:
        "Любой вопрос, на который вы ответили неправильно, автоматически добавляется в раздел ошибочных вопросов.",
      step2: "ШАГ 2",
      step2Title: "Повторяйте со временем",
      step2Desc:
        "Приложение планирует будущие повторения в зависимости от того, насколько хорошо вы усваиваете каждый вопрос.",
      step3: "ШАГ 3",
      step3Title: "Повышайте уровень освоения",
      step3Desc:
        "Правильные ответы повышают уровень освоения. Если вы снова ошибётесь, вопрос останется в активной практике.",
      step4: "ШАГ 4",
      step4Title: "Освойте вопрос",
      step4Desc:
        "Ответьте правильно 3 раза подряд, и вопрос перейдёт в категорию освоенных.",
    },

    learningCenter: {
      title: "Учебный центр",
      subtitle: "Изучайте материалы MBLEx по разделам и темам.",
      backHome: "На главную",
      loadingUnits: "Загрузка учебных разделов...",
      unit: "Раздел",
      defaultUnitDescription: "Учебный раздел MBLEx",
      startLearning: "Начать обучение",
    },

    learningUnit: {
      unit: "Раздел",
      back: "Назад",
      loadingTopics: "Загрузка тем...",
      studyTopic: "Изучить тему",
    },

    learningTopic: {
      topic: "Тема",
      back: "Назад",
      partsReviewed: "Изучено частей: {reviewed} из {total}",
      complete: "завершено",
      learningContent: "Учебный материал",
      noContent: "Материалы по этой теме не найдены.",
      reviewed: "Изучено",
      undo: "Отменить",
      markReviewed: "Отметить как изученное",
      practice: "Практика",
      noExercises: "Для этой темы пока нет упражнений.",
    },

    account: {
      backToHome: "На главную",
      title: "Мой аккаунт",
      subtitle: "Управляйте аккаунтом, подпиской и доступом к обучению.",

      account: "АККАУНТ",
      profile: "Профиль",

      subscription: "ПОДПИСКА",
      currentPlan: "Текущий план",
      loading: "Загрузка...",

      superUserPremium: "Premium SuperUser",
      premiumTrial: "Пробный Premium",
      premiumMonthly: "Ежемесячный Premium",
      premiumQuarterly: "Квартальный Premium",
      premium: "Premium",
      freePlan: "Бесплатный план",

      permanentAccess: "Постоянный доступ",
      threeDayFreeTrial: "3-дневный бесплатный период",
      perMonthPrice: "$21.99 / месяц",
      perThreeMonthsPrice: "$59.97 / 3 месяца",
      freePrice: "$0",

      active: "Активна",
      paymentIssue: "Проблема с оплатой",
      trialActive: "Пробный период активен",
      cancellationScheduled: "Отмена запланирована",
      ended: "Завершена",
      free: "Бесплатно",

      permanentPremiumDesc: "У вас постоянный Premium-доступ.",
      trialEndsOn: "Бесплатный пробный период заканчивается {date}.",
      premiumTrialActive: "Ваш пробный Premium-период сейчас активен.",
      paymentPaused:
        "Ваш Premium-доступ временно приостановлен, поскольку платеж не удалось выполнить.",
      subscriptionEndsOn:
        "Ваша подписка завершится {date}. До этой даты Premium-доступ сохранится.",
      subscriptionCancellationScheduled: "Отмена вашей подписки запланирована.",
      subscriptionRenewsOn: "Ваша подписка будет продлена {date}.",
      previousSubscriptionEnded:
        "Ваша предыдущая Premium-подписка завершена. Ваш учебный прогресс сохранён.",
      usingFreePlan: "Сейчас вы используете бесплатный план.",

      updatePaymentMethod: "Обновить способ оплаты",
      manageSubscription: "Управление подпиской",

      plan: "План",
      status: "Статус",
      billing: "Оплата",
      trialEnds: "Окончание пробного периода",
      accessUntil: "Доступ до",
      nextBillingDate: "Следующая дата оплаты",

      notApplicable: "Не применяется",
      trial: "Пробный период",
      monthly: "Ежемесячно",
      quarterly: "Ежеквартально",
      permanent: "Постоянно",

      learningAccess: "ДОСТУП К ОБУЧЕНИЮ",
      yourAccess: "Ваш доступ",

      practiceQuestions: "Практические вопросы",
      unlimited: "Без ограничений",
      remaining: "Осталось: {count}",
      fullQuestionBankAccess: "Доступ ко всему банку вопросов",
      freeQuestionsUsed: "Использовано {used} из {limit} бесплатных вопросов",

      wrongQuestions: "Ошибочные ответы",
      included: "Включено",
      wrongQuestionsDesc: "Повторяйте вопросы, в которых вы ранее ошиблись.",

      learningCenter: "Учебный центр",
      unlocked: "Разблокировано",
      premiumAccess: "Premium",
      learningCenterDesc: "Структурированные учебные материалы и контент.",

      vocabulary: "Терминология",
      vocabularyDesc: "Изучение, повторение и практика терминологии.",

      premiumLabel: "PREMIUM",
      upgradeToPremium: "Перейти на Premium",
      upgradeDesc:
        "Получите доступ ко всему банку вопросов, Учебному центру, Терминологии и Premium-функциям обучения.",

      monthlyPlan: "Ежемесячный",
      quarterlyPlan: "Квартальный",
      perMonth: "в месяц",
      everyThreeMonths: "каждые 3 месяца",
      equivalentMonthly: "Эквивалент $19.99 / месяц",

      fullPremiumAccess: "Полный Premium-доступ",
      unlimitedAI: "Неограниченные объяснения ИИ",
      cancelAnytime: "Отмена в любое время",
      threeDayTrialEligible: "3-дневный пробный период для новых пользователей, соответствующих условиям",
      saveSixDollars: "Экономия $6 каждые 3 месяца",

      startMonthly: "Выбрать ежемесячный план",
      startQuarterly: "Выбрать квартальный план",
      mostValuable: "САМАЯ ВЫГОДНАЯ ЦЕНА",

      progressSaved: "Ваш прогресс всегда сохраняется",
      progressSavedDesc:
        "Отмена или изменение подписки не удаляет историю практики, ошибочные вопросы, прогресс освоения или учебные данные.",

      returnToHome: "Вернуться на главную",
      manualPaidAccess: "Premium-доступ с ручной активацией",
      manualPaidAccessDesc:
        "Ваш Premium-доступ был активирован напрямую ACE Massage Hub и действует до {date}.",
      noAutoRenewal: "Без автоматического продления",
      noAutoRenewalDesc:
        "Этот план не продлевается автоматически и не предусматривает автоматических списаний.",
      paymentSource: "Источник оплаты",
      manualPayment: "Оплата вручную",
      renewManualAccess: "Продлить доступ",
      renewManualAccessDesc:
        "Чтобы продлить доступ, свяжитесь с ACE Massage Hub.",
      contactForRenewal: "Контакты для продления",
      address: "Адрес",
      phone: "Телефон",
      wechat: "WeChat",
      email: "Электронная почта",

      otherPaymentOptions: "Другие способы оплаты",
      preferAnotherPaymentMethod: "Предпочитаете другой способ оплаты?",
      manualPaymentAvailable:
        "Мы также принимаем оплату вручную. Свяжитесь с ACE Massage Hub, чтобы приобрести Premium-доступ с оплатой наличными, через Zelle, Venmo, PayPal, банковским переводом или чеком.",
      manualPaymentNoAutoRenew:
        "Планы с ручной оплатой не продлеваются автоматически.",
      acceptedPaymentMethods: "Принимаем: наличные, Zelle, Venmo, PayPal, банковский перевод и чек",
    },

    footer: {
        copyright: "© 2026 Massage Exam Practice App. Все права защищены.",
        terms: "Условия использования",
        privacy: "Политика конфиденциальности",
        contact: "Связаться с нами",
    },
  },
};

export default translations;